import { getTypeFromStructuredStorageType } from '../constants';
import { BuiltinType } from './types';
export class BuiltinInstanceMemberStructuredStorageProperty {
    constructor(type, property) {
        this.type = type;
        this.property = property;
        this.types = new Set([BuiltinType.InstanceMemberValue]);
    }
    emitValue(sb, node, options, visited = false) {
        if (visited) {
            sb.emitOp(node, 'DROP');
        }
        if (options.pushValue) {
            sb.emitHelper(node, options, sb.helpers.createStructuredStorage({
                type: getTypeFromStructuredStorageType(this.type),
                prefix: this.property,
            }));
        }
    }
}

//# sourceMappingURL=BuiltinInstanceMemberStructuredStorageProperty.js.map
